import classNames from 'classnames';
import RadialAudioPlayer from 'components/atoms/audio-player/RadialAudioPlayer';
import { useTranslation } from 'react-i18next';
import { PiCheckCircleFill, PiCircleFill } from 'react-icons/pi';
import { ITrackResponse } from 'services/tracks/types';
import { STATUS } from 'services/types';
import './TrackSearchCard.scss';

interface ITrackSearchCardProps {
  track: ITrackResponse;
  isSelected?: boolean;
  onClick?: (track: ITrackResponse) => void;
}

const TrackSearchCard = ({ track, isSelected, onClick }: ITrackSearchCardProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(['track-search-card'], { isSelected })}
      onClick={() => onClick && onClick(track)}
    >
      <RadialAudioPlayer audioSrc={track.mp3PreviewLink ?? ''} playerId={track.id} size={80} />
      <div className="track-search-card-header">
        <div className="track-search-card-header-title">{track.mainTitle.title}</div>
        <div className="track-search-card-header-description">
          <div className="track-search-card-header-description-content">
            {track.mainTitle.version && (
              <>
                {track.mainTitle.version}
                <PiCircleFill />
              </>
            )}
            {t(`enum.STATUS.${STATUS[track.trackStatus]}`)}

            {track.isrc && (
              <>
                <PiCircleFill />
                {track.isrc}
              </>
            )}
          </div>
        </div>
      </div>
      {isSelected ? <PiCheckCircleFill /> : <PiCircleFill />}
    </div>
  );
};

export default TrackSearchCard;
